type TRBL = {
  top: string;
  right: string;
  bottom: string;
  left: string;
};

export const parseTRBL = (value: string | number): TRBL => {
  // if number, then
  if (typeof value === 'number') {
    return {
      top: `${value}px`,
      right: `${value}px`,
      bottom: `${value}px`,
      left: `${value}px`,
    };
  }

  const [top, right, bottom, left] = value.split(' ');

  if (top === undefined) {
    return { top: '0px', right: '0px', bottom: '0px', left: '0px' };
  }

  if (right === undefined) {
    return { top, right: top, bottom, left: top };
  }

  if (bottom === undefined) {
    return { top, right, bottom: right, left: right };
  }

  if (left === undefined) {
    return { top, right, bottom, left: top };
  }

  return { top, right, bottom, left };
};

export const TRBLString = (value: TRBL) => {
  return `${value.top} ${value.right} ${value.bottom} ${value.left}`;
};
